import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, HeartIcon, InstagramIcon } from 'lucide-react';
import type { Page } from '../App';
const galleryItems = [{
  id: 1,
  tag: '#MKLOUNGE',
  likes: '2.4K',
  gradient: 'linear-gradient(135deg, #050505 0%, #1a1000 50%, #C9A84C22 100%)',
  size: 'tall'
}, {
  id: 2,
  tag: 'FRIDAY NIGHTS',
  likes: '1.8K',
  gradient: 'linear-gradient(135deg, #0a0005 0%, #1a0010 50%, #C9A84C15 100%)',
  size: 'normal'
}, {
  id: 3,
  tag: 'VIP ONLY',
  likes: '3.1K',
  gradient: 'linear-gradient(135deg, #050a00 0%, #0a1500 50%, #C9A84C20 100%)',
  size: 'normal'
}, {
  id: 4,
  tag: 'BOTTLE SERVICE',
  likes: '2.9K',
  gradient: 'linear-gradient(135deg, #050505 0%, #201500 50%, #E8C97A18 100%)',
  size: 'wide'
}, {
  id: 5,
  tag: '#DCNIGHTLIFE',
  likes: '4.2K',
  gradient: 'linear-gradient(135deg, #000510 0%, #001020 50%, #C9A84C25 100%)',
  size: 'normal'
}, {
  id: 6,
  tag: 'SATURDAY VIBES',
  likes: '1.5K',
  gradient: 'linear-gradient(135deg, #100005 0%, #200010 50%, #C9A84C18 100%)',
  size: 'tall'
}, {
  id: 7,
  tag: 'GOLD HOUR',
  likes: '3.7K',
  gradient: 'linear-gradient(135deg, #050505 0%, #150a00 50%, #C9A84C30 100%)',
  size: 'normal'
}, {
  id: 8,
  tag: 'LATIN NIGHTS',
  likes: '2.2K',
  gradient: 'linear-gradient(135deg, #000a05 0%, #001510 50%, #C9A84C20 100%)',
  size: 'normal'
}, {
  id: 9,
  tag: '#MKLOUNGE',
  likes: '1.9K',
  gradient: 'linear-gradient(135deg, #0a0500 0%, #1a0a00 50%, #E8C97A22 100%)',
  size: 'wide'
}, {
  id: 10,
  tag: 'INDUSTRY SUNDAYS',
  likes: '2.6K',
  gradient: 'linear-gradient(135deg, #050010 0%, #0a0020 50%, #C9A84C15 100%)',
  size: 'normal'
}, {
  id: 11,
  tag: 'VIP SECTION',
  likes: '3.3K',
  gradient: 'linear-gradient(135deg, #100500 0%, #201000 50%, #C9A84C28 100%)',
  size: 'normal'
}, {
  id: 12,
  tag: 'SKYBOX SUITE',
  likes: '4.8K',
  gradient: 'linear-gradient(135deg, #050505 0%, #0a0a00 50%, #E8C97A20 100%)',
  size: 'tall'
}];
export function GalleryPage({
  onBack
}: {
  onBack: () => void;
}) {
  const [lightboxItem, setLightboxItem] = useState<(typeof galleryItems)[0] | null>(null);
  return <div className="min-h-screen w-full bg-[#050505] pt-24 pb-20 px-4 sm:px-6" data-id="element-887">
      <div className="max-w-7xl mx-auto" data-id="element-888">
        {/* Back */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} onClick={onBack} className="flex items-center gap-2 font-montserrat text-[12px] tracking-widest text-white/40 hover:text-[#C9A84C] transition-colors duration-300 mb-10" data-id="element-889">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" data-id="element-890">
            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-891" />
          </svg>
          BACK TO HOME
        </motion.button>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-892">
          <span className="font-inter text-[13px] tracking-[0.4em] text-[#C9A84C]/60 uppercase" data-id="element-893">
            Follow The Vibe
          </span>
          <h1 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2" data-id="element-894">
            GALLERY
          </h1>
          <div className="w-14 h-px bg-[#C9A84C]/50 mx-auto mt-4 mb-4" data-id="element-895" />
          <a href="https://instagram.com/mkloungedc" target="_blank" rel="noopener noreferrer" className="font-inter text-[15px] text-[#C9A84C] hover:text-[#E8C97A] transition-colors" data-id="element-896">
            @mkloungedc
          </a>
        </motion.div>

        {/* Masonry-style grid */}
        <div className="columns-2 sm:columns-3 lg:columns-4 gap-4 space-y-4" data-id="element-897">
          {galleryItems.map((item, i) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: i * 0.04
        }} onClick={() => setLightboxItem(item)} className="break-inside-avoid rounded-2xl overflow-hidden relative group cursor-pointer" style={{
          background: item.gradient,
          height: item.size === 'tall' ? 320 : item.size === 'wide' ? 200 : 240
        }} data-id="element-898">
              <div className="absolute inset-0 bg-gradient-to-br from-[#C9A84C]/0 to-[#C9A84C]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-400" data-id="element-899" />
              <div className="absolute inset-0 opacity-5" data-id="element-900">
                <div className="absolute left-1/3 top-0 bottom-0 w-px bg-white" data-id="element-901" />
                <div className="absolute left-2/3 top-0 bottom-0 w-px bg-white" data-id="element-902" />
                <div className="absolute top-1/3 left-0 right-0 h-px bg-white" data-id="element-903" />
                <div className="absolute top-2/3 left-0 right-0 h-px bg-white" data-id="element-904" />
              </div>
              {/* Instagram icon */}
              <div className="absolute top-3 right-3 opacity-30 group-hover:opacity-70 transition-opacity" data-id="element-905">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" data-id="element-906">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-907" />
                  <circle cx="12" cy="12" r="4" data-id="element-908" />
                  <circle cx="17.5" cy="6.5" r="1" fill="#C9A84C" stroke="none" data-id="element-909" />
                </svg>
              </div>
              {/* Tag + likes */}
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/80 to-transparent" data-id="element-910">
                <p className="font-montserrat font-700 text-[13px] tracking-widest text-[#C9A84C]" data-id="element-911">
                  {item.tag}
                </p>
                <div className="flex items-center gap-1 mt-0.5" data-id="element-912">
                  <HeartIcon size={10} className="text-white/40" data-id="element-913" />
                  <p className="font-inter text-[12px] text-white/50" data-id="element-914">
                    {item.likes}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Follow CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="text-center mt-14" data-id="element-915">
          <a href="https://instagram.com/mkloungedc" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 font-montserrat font-black text-[13px] tracking-widest border border-[#C9A84C]/40 text-[#C9A84C] px-8 py-4 rounded-2xl hover:bg-[#C9A84C]/10 hover:border-[#C9A84C] transition-all duration-300" data-id="element-916">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-917">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-918" />
              <circle cx="12" cy="12" r="4" data-id="element-919" />
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" data-id="element-920" />
            </svg>
            FOLLOW ON INSTAGRAM
          </a>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence data-id="element-921">
        {lightboxItem && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{
        background: 'rgba(5,5,5,0.95)',
        backdropFilter: 'blur(20px)'
      }} onClick={() => setLightboxItem(null)} data-id="element-922">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 28
        }} className="relative rounded-3xl overflow-hidden max-w-sm w-full" style={{
          background: lightboxItem.gradient,
          height: 420
        }} onClick={e => e.stopPropagation()} data-id="element-923">
              <div className="absolute inset-0 opacity-5" data-id="element-924">
                <div className="absolute left-1/3 top-0 bottom-0 w-px bg-white" data-id="element-925" />
                <div className="absolute left-2/3 top-0 bottom-0 w-px bg-white" data-id="element-926" />
                <div className="absolute top-1/3 left-0 right-0 h-px bg-white" data-id="element-927" />
                <div className="absolute top-2/3 left-0 right-0 h-px bg-white" data-id="element-928" />
              </div>
              <button onClick={() => setLightboxItem(null)} className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center border border-white/20 text-white/60 hover:text-white transition-colors" style={{
            background: 'rgba(5,5,5,0.6)'
          }} data-id="element-929">
                <XIcon size={14} data-id="element-930" />
              </button>
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/90 to-transparent" data-id="element-931">
                <p className="font-montserrat font-black text-[15px] tracking-widest text-[#C9A84C]" data-id="element-932">
                  {lightboxItem.tag}
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-933">
                  <HeartIcon size={12} className="text-white/50" data-id="element-934" />
                  <span className="font-inter text-[13px] text-white/50" data-id="element-935">
                    {lightboxItem.likes} likes
                  </span>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}